<!-- 委托加工入库单状态 -->
<template>
  <base-form
    v-model="formData"
    :options="options"
    ref="topData"
    :rules="rules"
    :disabled="!canEdit"
    @input="handleChange"
    label-width="100px"
  >
  </base-form>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseForm from '@/components/form/base-form';
  // import API from '@/api/wareHouse/mcInbound.js';
  // import BASE_API from '@/api/dataBase';

  export default {
    name: 'entryListStatus',
    components: {
      BaseForm,
    },
    props: {
      costInfo: {
        type: Object,
        default: () => {},
      },
      dictList: {
        type: Object,
        default: () => {},
      },
      canEdit: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      options() {
        return [
          {
            type: 'input',
            label: this.$t('mcInboundEdit.entryListStatus.inboundNo'),
            prop: 'inboundNo',
            clearable: true,
            placeholder: this.$t('mcInboundEdit.entryListStatus.defaultPlaceholder'),
            disabled: true,
          }, //委托加工入库单号
          {
            type: 'input',
            label: this.$t('mcInboundEdit.entryListStatus.inboundCreatePersonNo'),
            placeholder: this.$t('mcInboundEdit.entryListStatus.defaultPlaceholder'),
            prop: 'inboundCreatePersonName',
            currentValue: this.formData.inboundCreatePersonName,
            clearable: true,
            disabled: true,
          }, //制单人
          {
            type: 'date',
            label: this.$t('mcInboundEdit.entryListStatus.inboundCreateDate'),
            placeholder: this.$t('mcInboundEdit.entryListStatus.inboundCreateDatePlaceholder'),
            prop: 'inboundCreateDate',
            disabled: true,
            clearable: true,
          }, //制单日期
          {
            type: 'input',
            label: this.$t('mcInboundEdit.entryListStatus.inboundCompanyCode'),
            placeholder: this.$t('mcInboundEdit.entryListStatus.defaultPlaceholder'),
            prop: 'inboundCompanyName',
            currentValue: this.formData.inboundCompanyName,
            clearable: true,
            disabled: true,
          }, //公司
          {
            type: 'dict',
            label: this.$t('mcInboundEdit.entryListStatus.inboundStatus'),
            prop: 'inboundStatus',
            dictType: 'mc_inbound_status',
            clearable: true,
            disabled: true,
          }, //委托加工入库单状态
          {
            type: 'dict',
            label: this.$t('mcInboundEdit.entryListStatus.accountingStatus'),
            placeholder: this.$t('mcInboundEdit.entryListStatus.defaultPlaceholder'),
            prop: 'accountingStatus',
            dictType: 'post_status',
            clearable: true,
            disabled: true,
          }, //财务入库状态
          {
            type: 'input',
            label: this.$t('mcInboundEdit.entryListStatus.isWriteOff'),
            placeholder: this.$t('mcInboundEdit.entryListStatus.defaultPlaceholder'),
            prop: 'isWriteOff',
            currentValue: this.formData.isWriteOff,
            clearable: true,
            disabled: true,
          }, //是否已冲销
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      rules() {
        return false;
      },
    },
    watch: {
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
      costInfo: {
        handler(newValue) {
          this.formData.inboundQuantity = newValue.inboundQuantity;
          this.formData.settlementPrice = newValue.settlementPrice;
          this.formData.settlementAmount = newValue.settlementAmount;
          console.log(newValue);
          console.log(this.formData);
        },
        deep: true,
      },
    },
    data() {
      return {
        formData: {
          id: '',
          inboundNo: '', //委托加工入库单号
          inboundCreateDate: '', //制单日期
          inboundCreatePersonNo: '', //制单人
          inboundCreatePersonName: '', //制单人
          inboundCompanyCode: '', //公司
          inboundCompanyName: '', //公司
          inboundStatus: '', //委托加工入库单状态
          accountingStatus: '', //财务入库状态
          isWriteOff: '', //是否已冲销
        },
        initFlag: true, //查询详情进入页面时，先不执行handleChange
        companyList: [],
        departmentList: [],
      };
    },
    mounted() {
      // this.getCompany();
    },
    methods: {
      getDetail(data) {
        this.formData = data;
        this.formData.isWriteOff = this.formData.inboundStatus == 'MCZT06' ? '是' : '否'; //是否已冲销
        this.initFlag = true;
        this.$nextTick(() => {
          this.initFlag = false;
        });
      },
      handleChange(v, prop) {
        console.log(v, prop);
      },

      // 千分位
      toLocaleString(num) {
        return num && num.toLocaleString();
      },

      // 校验
      getVal() {
        return new Promise((resolve, reject) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rate .el-form-item__content {
    display: flex;
  }
</style>
